import React, { useEffect, useRef } from "react";
import LoaderSpinner from "react-loader-spinner";
import classnames from "classnames";
import styles from "./Loader.module.scss";

type Props = {
  children?: React.ReactNode;
  isLoading?: boolean;
};

const changeTabIndex = (parent: Element | Document, tabIndex: number) => {
  const items = Array.from(
    parent.querySelectorAll<HTMLElement>("a, button, input, select, textarea")
  );

  for (let item of items) {
    item.setAttribute("tabindex", `${tabIndex}`);
  }
};

const Loader = ({ isLoading, children }: Props) => {
  const loaderContentRef = useRef(null);

  useEffect(() => {
    const tabIndexValue = isLoading ? -1 : 0;
    if (children) {
      changeTabIndex(loaderContentRef.current, tabIndexValue);
    } else {
      changeTabIndex(document, tabIndexValue);
    }
  }, [isLoading]);

  return (
    <>
      <div
        className={classnames(styles["Loader"], {
          [styles["Loader--active"]]: isLoading && children,
          [styles["Loader--active-fullscreen"]]: isLoading && !children
        })}
      >
        <>
          {isLoading ? (
            <div className={styles["overlay"]}>
              <div className={styles["spinner"]}>
                <LoaderSpinner
                  type="TailSpin"
                  color="currentColor"
                  height={50}
                  width={50}
                />
              </div>
            </div>
          ) : null}
          {children ? (
            <div ref={loaderContentRef} className={styles["content"]}>
              {children}
            </div>
          ) : null}
        </>
      </div>
    </>
  );
};

export default Loader;
